import { LocalStoreService } from './local-store.service';
import { DotSettings } from './settings.model';
import { AppConfig } from './app.config';
import { Inject, Injectable, NgModule } from '@angular/core';
import { SiteBrowserState } from './site-browser.state';
/**
 * Stores and returns the DotSettings class
 */
var SettingsStorageService = (function () {
    function SettingsStorageService(config, localStoreService, siteBrowserState) {
        this.config = config;
        this.localStoreService = localStoreService;
        this.siteBrowserState = siteBrowserState;
        this.configKey = config.dotCMSURLKey;
    }
    SettingsStorageService.prototype.getSettings = function () {
        var dSettings = JSON.parse(this.localStoreService.getValue(this.configKey));
        if (dSettings == null) {
            dSettings = new DotSettings();
        }
        return dSettings;
    };
    /**
     * Stores the DotSettings object
     * @param siteURL
     * @param JWT
     */
    SettingsStorageService.prototype.storeSettings = function (siteURL, JWT) {
        var dSettings = new DotSettings();
        dSettings.site = siteURL;
        dSettings.jwt = JWT;
        this.localStoreService.storeValue(this.configKey, JSON.stringify(dSettings));
    };
    /**
     * removes stored settings
     */
    SettingsStorageService.prototype.clearSettings = function () {
        this.localStoreService.clearValue(this.configKey);
    };
    return SettingsStorageService;
}());
export { SettingsStorageService };
SettingsStorageService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['config',] },
    { type: Inject, args: ['localStoreService',] },
    { type: Inject, args: ['siteBrowserState',] },
];
/** @nocollapse */
SettingsStorageService.ctorParameters = function () { return [
    { type: AppConfig, },
    { type: LocalStoreService, },
    { type: SiteBrowserState, },
]; };
var DotSettingsStorageModule = (function () {
    function DotSettingsStorageModule() {
    }
    return DotSettingsStorageModule;
}());
export { DotSettingsStorageModule };
DotSettingsStorageModule.decorators = [
    { type: NgModule, args: [{
                providers: [SiteBrowserState, AppConfig, LocalStoreService, SettingsStorageService]
            },] },
];
/** @nocollapse */
DotSettingsStorageModule.ctorParameters = function () { return []; };
//# sourceMappingURL=settings-storage.service.js.map